<template>
    <div>
        <div class="load" v-if="isLoading"><loader></loader></div>
        <div v-else>
            <button class="btn btn-add-group" @click="activeExtra(dataAsideMenu.id)">
                <i class="fas fa-plus fa-ms"></i> {{ $t("lang.label_additional") }}
            </button>
            <br /><br />
            <div
                class="form-row"
                v-if="displayExtra"
                style="width: 100%; padding: 0px 15px"
            >
                <form
                    @submit.prevent="saveCatExtas(dataAsideMenu.id)"
                    style="width: 100%"
                >
                    <div class="row">
                        <label>{{ $t("lang.label_new_extra") }}:</label>
                        <div class="form-group col-md-12">
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="category"
                                    style="border: 1px solid #b1b1b1"
                                    v-model="category"
                                />
                                <div class="input-group-prepend">
                                    <button
                                        type="submit"
                                        class="btn btn-info"
                                        :disabled="btnSave"
                                    >
                                        <i class="fas fa-save fa-ms"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <form
                    @submit.prevent="CopiarExtas(dataAsideMenu.id)"
                    style="width: 100%"
                    v-if="options.length > 0"
                >
                    <div class="row" v-if="options[0].list.length > 0">
                        <label>{{ $t("lang.label_cop_extra") }}:</label>
                        <div class="form-group col-md-12">
                            <div class="input-group">
                                <multiselect
                                    v-model="copiarExtra"
                                    :options="options"
                                    :multiple="false"
                                    group-values="list"
                                    group-label="food"
                                    :group-select="false"
                                    placeholder="Type to search"
                                    track-by="name"
                                    label="name"
                                    ></multiselect
                                >
                                <div class="input-group-prepend">
                                    <button
                                        type="submit"
                                        class="btn btn-info"
                                        :disabled="btnSave"
                                    >
                                        <i class="far fa-copy fa-ms"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <button class="btn btn-add-group" @click="hiddenCat()">
                    {{ $t("lang.label_cancel") }}
                </button>
            </div>
            <div class="extras-addicionales" v-else>
                <div class="extras-category" v-for="(i, index) in demoCat" :key="index">
                    <div class="card-header header-cat-title" @click="showCat(i.id)">
                        <div v-if="editCatExtra !== i.id">
                            <i class="fas fa-chevron-up" v-if="showCatExtra === i.id"></i>
                            <i class="fas fa-chevron-down" v-else></i>
                            <span> {{ i.name }}</span>
                            <span class="cdropdown btnViewMore float-right">
                                <button><i class="fas fa-ellipsis-v"></i></button>
                                <label>
                                    <input type="checkbox" />
                                    <ul v-if="showCatExtra === i.id">
                                        <li @click="activateEditCat(i.id, i.name)">
                                            {{ $t("lang.label_edit") }}
                                        </li>
                                        <li @click="delCat(i)">
                                            {{ $t("lang.label_del") }}
                                        </li>
                                    </ul>
                                </label>
                            </span>
                        </div>
                        <div v-else>
                            <form @submit.prevent="editCat">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formEditCat.name"
                                        style="border: 1px solid #b1b1b1"
                                    />
                                    <div class="input-group-prepend">
                                        <button
                                            type="submit"
                                            class="btn btn-info"
                                            :disabled="btnSave"
                                        >
                                            <i class="fas fa-save fa-ms"></i>
                                        </button>
                                    </div>
                                    <div class="input-group-prepend">
                                        <button
                                            type="button"
                                            class="btn btn-add-group2"
                                            @click="cancelEditCat"
                                        >
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div
                        v-bind:class="[
                            {
                                activeLista: showCatExtra === i.id,
                                showformop: showOP === i.id,
                            },
                            'extras-opciones',
                        ]"
                    >
                        <div class="extra-content">
                            <ul class="list-group" v-if="showOP !== i.id">
                                <li
                                    class="list-group-item"
                                    v-for="(j, k) in i.extras"
                                    :key="k"
                                >
                                    <span>{{ j.name }} </span>
                                    <span class="cdropdown btnViewMore float-right">
                                        <button><i class="fas fa-ellipsis-v"></i></button>
                                        <label>
                                            <input type="checkbox" />
                                            <ul>
                                                <li
                                                    @click="
                                                        activateEditAdi(
                                                            i.id,
                                                            j.id,
                                                            j.name,
                                                            j.incluir,
                                                            j.description,
                                                            j.price,
                                                        )
                                                    "
                                                >
                                                    {{ $t("lang.label_edit") }}
                                                </li>
                                                <li @click="delAdi(j.id)">
                                                    {{ $t("lang.label_del") }}
                                                </li>
                                            </ul>
                                        </label>
                                    </span>
                                    <span
                                        class="badge badge-pill badge-light float-right extra-price"
                                        >{{ currency }}{{ j.price | formatMoney }}</span
                                    >
                                </li>
                            </ul>
                            <!-- formulario para extras -->
                            <div
                                v-bind:class="[
                                    { activeForm: showOP === i.id },
                                    'form-extra-add add-op-' + i.id,
                                ]"
                            >
                                <form
                                    :class="'form-horizontal form-op' + i.id"
                                    @submit.prevent="setOptiones(i.id)"
                                >
                                    <div class="row">
                                        <div class="form-group col-md-8">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="formOp.name"
                                                placeholder="Nombre"
                                            />
                                        </div>
                                        <div class="form-group col-md-4">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="formOp.price"
                                                placeholder="Precio"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <textarea 
                                                v-model="formOp.description" 
                                                maxlength="500" placeholder="Descripcion" 
                                                class="form-control"
                                                style="width: 100% !important;"
                                            ></textarea>                                                                                 
                                        </div>
                                    </div>                                    
                                    <div class="row">
                                        <div class="form-group col-md-5">
                                            <div class="btn-group" data-toggle="buttons">
                                                <label class="btn btn-add-group2">
                                                    <input
                                                        type="checkbox"
                                                        :checked="preselect"
                                                        autocomplete="off"
                                                        v-model="preselect"
                                                    />
                                                    (Pre-select)
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-2">
                                            <button
                                                type="submit"
                                                class="btn btn-primary"
                                                :disabled="btnSave"
                                            >
                                                <i class="fas fa-save fa-ms"></i>
                                            </button>
                                        </div>
                                        <div class="form-group col-md-2">
                                            <button
                                                type="button"
                                                class="btn btn-add-group2"
                                                @click="cancelOP"
                                            >
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="row-add-extras" v-if="showOP !== i.id">
                                <button class="btn btn-add-group2" @click="adOp(i.id)">
                                    {{ $t("lang.label_add_opcions") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
export default {
    name: "extas",
    components: {
        Loader,
        Multiselect,
    },
    data () {
        return {
            displayExtra: false,
            isLoading: false,
            category: "",
            demoCat: [],
            double: [],
            showCatExtra: 0,
            editCatExtra: 0,
            showOP: 0,
            preselect: false,
            formOp: {
                id: 0,
                user_id: window.master_client,
                org_id: window.localuserdata,
                cat_id: 0,
                name: "",
                description:"",
                price: 0,
                incluir: 0,
                required: 0,
                status: 1,
                food_id:0,
            },
            formEditCat: {
                user_id: window.master_client,
                org_id: window.localuserdata,
                cat_id: 0,
                name: "",
            },
            btnSave: false,
            options: [],
            Alloptions: [],
            copiarExtra: [],
            currency: localStorage.getItem("currency"),
        }
    },
    created () {
        this.getExtra(this.dataAsideMenu.id);
        //console.log('dataAsideMenu', this.dataAsideMenu)
    },
    methods: {
        hiddenCat() {
            this.displayExtra = false;
        },
        CopiarExtas(id_food) {
            if (id_food > 0 && this.copiarExtra["id"] > 0) {
                this.btnSave = true;
                let formData = new FormData();
                formData.append("org_id", window.localuserdata);
                formData.append("user_id", window.master_client);
                formData.append("food_id", id_food);
                formData.append("status", 1);
                formData.append("id", this.copiarExtra["id"]); //category_id
                window.master
                    .post("/menu/category/extras/CopiarExtas", formData)
                    .then((response) => {
                        console.log(response.data);
                        this.displayExtra = false;
                        this.btnSave = false;
                        this.getExtra(this.dataAsideMenu.id);
                        this.AllGetExtras(this.dataAsideMenu.id);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.displayExtra = false;
                        this.btnSave = false;
                    });
            } else {
                console.log(
                    "error al copiar food=" + id_food + " cat_id=",
                    this.copiarExtra["id"]
                );
            }
        },
        AllGetExtras(id_food) {
            this.isLoading = true;
            window.master
                .get(
                    "/menu/category/extras/AllFood/" +
                        window.master_client +
                        "/" +
                        window.localuserdata +
                        "/" +
                        id_food
                )
                .then((response) => {
                    let r = response.data.res;
                    //debugger;
                    this.Alloptions = []
                    this.Alloptions = r;
                    response.data.status;
                    // console.log("AllFood", response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        cancelEditCat() {
            this.editCatExtra = 0;
            this.formEditCat.cat_id = 0;
            this.formEditCat.name = "";
        },
        activateEditCat(i, n) {
            this.editCatExtra = i;
            this.formEditCat.cat_id = i;
            this.formEditCat.name = n;
        },
        editCat() {
            if (this.formEditCat.name.length > 0) {
                this.btnSave = true;
                window.master
                    .post("/menu/category/extras/editCat", this.formEditCat)
                    .then((response) => {
                        console.log(response.data);
                        this.btnSave = false;
                        this.cancelEditCat();
                        this.getExtra(this.dataAsideMenu.id);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.btnSave = false;
                    });
            } else {
                this.cancelEditCat();
            }
        },
        delCat(i) {
            this.$swal({
                title: window.lang2.label_del_extra,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    window.master
                        .post("/menu/category/extras/delcatfood",
                            {
                                id: i.id,
                                food_id: this.dataAsideMenu.id,
                                org_id: window.localuserdata,
                                user_id: window.master_client,
                                extras: i.extras,
                            }
                        )
                        .then((response) => {
                            console.log(response.data);
                            this.getExtra(this.dataAsideMenu.id);
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        delAdi(i) {
            this.$swal({
                title: window.lang2.label_del_extra,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    window.master
                        .delete(
                            "/menu/category/extras/delAdi/" +
                                i +
                                "/" +
                                window.localuserdata +
                                "/" +
                                window.master_client,
                            {
                                id: i,
                                org_id: window.localuserdata,
                                user_id: window.master_client,
                            }
                        )
                        .then((response) => {
                            console.log(response.data);
                            this.getExtra(this.dataAsideMenu.id);
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        showCat(i) {
            this.showCatExtra = i;
        },
        adOp(i) {
            this.showOP = i;
        },
        activeExtra(id_food) {
            console.log(id_food);
            this.displayExtra = !this.displayExtra;
            if (this.displayExtra === true) {
                this.showCatExtra = 0;
            }
        },
        cancelOP() {
            this.showOP = 0;
            this.formOp.id = 0;
            this.formOp.cat_id = 0;
            this.formOp.name = "";
            this.formOp.description = "";
            this.formOp.price = 0;
            this.formOp.incluir = 0;
        },
        activateEditAdi(cat_id, i, n, p, d, price) {
            this.formOp.id = i;
            this.formOp.name = n;
            this.formOp.description = d;
            this.formOp.incluir = p;
            this.formOp.price = price;
            this.preselect = p > 0 ? true : false;
            this.showOP = cat_id;
        },
        setOptiones(cat_id) {
            if (this.formOp.name.length > 0) {
                this.btnSave = true;
                this.formOp.cat_id = cat_id;
                this.formOp.food_id = this.dataAsideMenu.id;
                let url = "/menu/category/extras/setOptiones";
                if (this.formOp.id > 0) {
                    url = "/menu/category/extras/editAdi";
                }
                window.master
                    .post(url, this.formOp)
                    .then((response) => {
                        console.log(response.data);
                        this.cancelOP();
                        this.getExtra(this.dataAsideMenu.id);
                        this.displayExtra = false;
                        this.btnSave = false;
                    })
                    .catch((error) => {
                        this.displayExtra = false;
                        this.btnSave = false;
                        console.log(error);
                    });
            }
        },
        saveCatExtas(id_food) {
            if (this.category.length > 0 && id_food !== "") {
                this.btnSave = true;
                let formData = new FormData();
                formData.append("category", this.category);
                formData.append("org_id", window.localuserdata);
                formData.append("user_id", window.master_client);
                formData.append("food_id", id_food);
                formData.append("status", 1);
                window.master
                    .post("/menu/category/extras/add", formData)
                    .then((response) => {
                        console.log(response.data);
                        this.displayExtra = false;
                        this.btnSave = false;
                        this.category = "";
                        this.getExtra(this.dataAsideMenu.id);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.displayExtra = false;
                        this.btnSave = false;
                    });
            } else {
                this.displayExtra = false;
                this.btnSave = false;
            }
        },
        getExtra(id_food) {
            this.AllGetExtras(id_food);
            this.isLoading = true;
            window.master
                .get(
                    "/menu/category/extras/GetExtras/" +
                        window.master_client +
                        "/" +
                        window.localuserdata +
                        "/" +
                        id_food
                )
                .then((response) => {
                    let r = response.data.res;
                    this.demoCat = r;
                    let demoCat = this.demoCat
                    
                    let filter = []
                    if (demoCat !== undefined) {
                        let opt = this.Alloptions[0].list;
                        filter = this.filerArrayKeyValue(opt, demoCat)
                        this.Alloptions[0].list = []   
                        this.Alloptions[0].list = filter                        
                    }
                    
                    this.options = this.Alloptions
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        filerArrayKeyValue(a, b){
            let filter = a.filter(function(array_el){
                return b.filter(function(anotherOne_el){
                    return anotherOne_el.id == array_el.id;
                }).length == 0
            });
            return filter
        }
    },
    computed: {
        ...mapGetters(["get_menuCatActive", "dataAsideMenu"]),
    },
    watch: {
        dataAsideMenu: function () {
            console.log("existFoods = ", this.dataAsideMenu.id);
            this.getExtra(this.dataAsideMenu.id);
            this.displayExtra = false;
        },
        preselect: function () {
            this.formOp.incluir = this.preselect === true ? 1 : 0;
        },
    },
}
</script>

<style lang="scss" scoped>
.extra-content {
    padding: 0px 1px 5px 5px;
}
.extra-content ul.list-group li.list-group-item {
    padding: 5px;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.btn-add-group2 {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: auto;
    display: block;
    margin: 0px auto;
}
.cdropdown.btnViewMore > a:before,
.cdropdown.btnViewMore > button:before {
    content: "" !important;
    border-top: 0px;
    border-left: 0px;
    top: 0px;
    right: 0px;
    border-right: 0px;
}
.cdropdown.btnViewMore > a,
.cdropdown.btnViewMore > button {
    padding-right: 5px;
    padding-left: 5px;
    border: 0px;
}
.cdropdown.btnViewMore ul {
    right: 0px;
}
span.cdropdown.btnViewMore.float-right button {
    padding: 0px;
}
.extra-price {
    margin-right: 10px;
}
.row-add-extras {
    margin: 20px 0px 0px 0px;
}
.form-extra-add {
    display: none;
}
.form-extra-add.activeForm {
    display: block;
}

.extras-opciones {
    height: 0px;
    transform: scaleY(0);
    overflow: hidden;
    transition: transform 0.3s ease-out;
}
.activeLista.extras-opciones {
    overflow: initial !important;
    height: auto !important;
    transform: scaleY(1);
    transform-origin: top;
    border: 1px solid #727272;
    border-top: 0px;
    padding-top: 5px;
}
.activeLista.showformop.extras-opciones .extra-content {
    padding-left: 0px !important;
}
form.form-horizontal {
    background: #f7f7f7;
    padding: 5px;
}
form.form-horizontal input[type="text"] {
    border: 1px solid rgb(177, 177, 177);
}
.card-header.header-cat-title {
    color: #727272;
    font-size: 14px;
    font-weight: bold;
    border: 1px solid #727272;
    margin-top: 5px;
}
.multiselect {
    max-width: 210px;
}
.multiselect__tags {
    border: 1px solid #b1b1b1;
    border-top-left-radius: 2px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 2px;
}
.form-control {
    width: 80% !important;
}
</style>
